import { configureStore } from "@reduxjs/toolkit";
import sidebarSlice from "../sidebar/toggleSlice";
import saleSlice from "../components/sale/saleSlice";
export const store = configureStore({
  reducer: {
    sidebar: sidebarSlice,
    sale: saleSlice,
  },
});
